export enum ContentPriorityType {
  LOW = "CONTENT_PRIORITY_LOW",
  MEDIUM = "CONTENT_PRIORITY_MEDIUM",
  HIGH = "CONTENT_PRIORITY_HIGH",
}
